/* Base class (component) for the widgets. If any of the widgets have used RxJs Observable/Subject subscribe() method, those widget components needs to extend
** form this base class as the unsubscription will be handled here.
*/
import { OnDestroy } from '@angular/core';
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/takeUntil";

export abstract class BaseWidgetComponent implements OnDestroy {

  protected emitUnsubscribe: Subject<void> = new Subject();

  constructor() {
  }

  ngOnDestroy() {
    this.emitUnsubscribe.next();
    this.emitUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/base-widget.component.ts